// 克罗地亚语
import hrLocale from 'element-ui/lib/locale/lang/hr'


const hr = {
  // ============= 登录 start ============
  "验证码": "Kod za verifikaciju",
  "登录": "Prijaviti se",
  "请输入验证码": "Molimo unesite kod za verifikaciju",
  "验证码不正确!": "Pogrešan kod za verifikaciju!",
  "请输入账号": "Molimo unesite korisnički račun",
  "请输入密码": "Molimo unesite lozinku",
  "访问地址有误，请在shop后台核实": "Adresa za pristup nije ispravna, molimo provjerite u backendu trgovine",
  // ============= 登录 end ============

  // ============= Layout start ============
  "全屏模式": "Puni ekran",
  "首页": "Početna stranica",
  "此操作将退出登录, 是否继续?": "Ova operacija će vas odjaviti, želite li nastaviti?",
  "已取消退出": "Odjava otkazana",
  "您有一个新订单": "Imate novi zahtjev",
  "无法获取当前门店信息，请重新登录": "Informacije o trenutnoj trgovini nisu dostupne, molimo prijavite se ponovno",
  "收银台": "Blagajna",
  "收银": "Blagajna",
  "桌台": "Stol",
  "订单": "Narudžba",
  // ============= Layout end ============

  // ============= 首页 start ============
  "查询会员": "Pretraga člana",
  "商品改价": "Promijeni cijenu proizvoda",
  "商品删行": "Izbriši stavku proizvoda",
  "整单取消": "Otkaz cijele narudžbe",
  "挂单": "Drži narudžbu",
  "折扣": "Popust",
  "抹零": "Zaokruži",
  "请输入内容": "Molimo unesite sadržaj",
  "收银员": "Blagajnik",
  "店内就餐": "Konobarstvo",
  "打包带走": "Paketiranje za ponijeti",
  "商品名称": "Naziv proizvoda",
  "商品价格": "Cijena proizvoda",
  "商品数量": "Količina proizvoda",
  "应收": "Za naplatu",
  "包装费": "Naknada za pakiranje",
  "优惠": "Popust",
  "数量": "Količina",
  "件": "Kom.",
  "实收": "Primljeno",
  "收款": "Primanje plaćanja",
  "请选择商品": "Odaberite proizvode",
  "确定要删除": "Jeste li sigurni da želite izbrisati",
  "提示": "Savjet",
  "确定": "Potvrdi",
  "取消": "Odustani",
  "请先将购物车内的商品挂单或结账后再取单": "Molimo postavite ili platite stavke u košarici prije preuzimanja narudžbe",
  "确定要整单取消吗?": "Jeste li sigurni da želite otkazati cijelu narudžbu?",
  "请输入会员手机号查询会员，输入完毕后点击确认": "Unesite broj telefona člana za pretragu, zatim kliknite na potvrdi",
  "请输入会员手机号": "Molimo unesite broj telefona člana",
  "会员昵称": "Nadimak člana",
  "余额总计": "Ukupan saldo",
  "退出": "Izlaz",
  "该用户不存在": "Taj korisnik ne postoji",
  "折扣抹零": "Popust / Zaokruživanje",
  "当前价格": "Trenutna cijena",
  "改价": "Promijeni cijenu",
  "实付价格": "Stvarna cijena",
  "请输入实付价格": "Molimo unesite stvarnu cijenu",
  "优惠折扣": "Stopa popusta",
  "请输入优惠折扣": "Molimo unesite stopu popusta",
  "抹分": "Zaokruži na desetinke",
  "抹角": "Zaokruži na dolare",
  "四舍五入到角": "Zaokruži na najbližu desetinku",
  "四舍五入到元": "Zaokruži na najbliži dolar",
  "确 定": "Potvrdi",
  "价格不能为空": "Cijena ne može biti prazna",
  "折扣不能为空": "Popust ne može biti prazan",
  "修改价格": "Promijeni cijenu",
  "本次售价": "Trenutna prodajna cijena",
  "请输入本次售价": "Molimo unesite trenutnu prodajnu cijenu",
  "清空": "Očisti",
  "确认": "Potvrdi",
  "商品详情": "Detalji proizvoda",
  "单位": "Jedinica",
  "规格": "Specifikacija",
  "加料": "Dodatni sastojci",
  "取 消": "Poništi",
  "现金收款": "Gotovinska naplata",
  "余额收款": "Naplata salda",
  "其他方式": "Druge metode",
  "应收金额": "Ukupni iznos za naplatu",
  "用户通过店内扫码等方式进行支付，确认用户支付成功后，点击确认付款即可完成付款操作。": "Korisnici mogu platiti korištenjem QR koda u trgovini i drugim metodama. Nakon što potvrdite uspješno plaćanje, kliknite 'Potvrdi plaćanje' kako biste završili transakciju.",
  "微信支付": "WeChat plaćanje",
  "支付宝支付": "Alipay plaćanje",
  "pos刷卡": "POS kartično plaćanje",
  "请输入会员ID号查询会员，输入完毕后点击确认": "Unesite ID člana za pretragu člana, zatim kliknite na potvrdi",
  "请输入会员ID": "Molimo unesite ID člana",
  "登录会员仅作为积分累计，无法享受其他优惠。": "Prijavljeni članovi mogu samo skupljati bodove i nisu predmet drugih popusta.",
  "取消收款": "Otkaži plaćanje",
  "订单总价": "Ukupna cijena narudžbe",
  "挂单时间": "Vrijeme čekanja narudžbe",
  "删除": "Izbriši",
  "取单": "Preuzmi narudžbu",
  "多语言小票打印": "Printanje računa na više jezika",
  "打印语言": "Jezik ispisa",
  "中文": "Kineski",
  "英语": "Engleski",
  "德语": "Njemački",
  "法语": "Francuski",
  "西班牙语": "Španjolski",
  "意大利语": "Talijanski",
  "克罗地亚": "Hrvatski",
  "斯洛文尼亚": "Slovenski",
  "匈牙利语": "Mađarski",
  "塞尔维亚语": "Srpski",
  // ============= 首页 end   ============

  // ============= 桌台 start ============
  "未开台": "Nije otvoreno",
  "已开台": "Otvoren stol",
  "就餐中": "Jedenje",
  "刷新": "Osvježi",
  "整单清空": "Isprazni cijelu narudžbu",
  "转台": "Promijeni stol",
  "打印预结单": "Printaj preliminarni račun",
  "催菜": "Požuri narudžbu",
  "人数": "Broj gostiju",
  "订单来源": "Izvor narudžbe",
  "请点击左侧桌号台": "Molimo kliknite na broj stola s lijeve strane",
  "点选已开台桌台，可以在此查看点餐信息。": "Odaberite otvoren stol kako biste vidjeli detalje naručivanja ovdje.",
  "服务费": "Naknada za uslugu",
  "税费": "Porez",
  "协助点餐": "Pomoć u naručivanju",
  "协助加餐": "Pomoć u dodavanju stavki",
  "结账": "Završi narudžbu",
  "完成": "Završi",
  "价格": "Cijena",
  "请选择": "Molimo odaberite",
  "确定要打印小票吗?": "Jeste li sigurni da želite isprintati račun?",
  "确定要关闭桌台并取消订单吗?": "Jeste li sigurni da želite zatvoriti stol i otkazati narudžbu?",
  "请选择桌号": "Molimo odaberite broj stola",
  "就餐人数": "Broj osoba za objed",
  "下单": "Naruči",
  "返回": "Natrag",
  "确定要商品删行吗?": "Jeste li sigurni da želite izbrisati stavku?",
  "请选择就餐人数": "Molimo odaberite broj gostiju",
  // ============= 桌台 end ============

  // ============= 订单 start ============
  "下单时间": "Vrijeme naručivanja",
  "起始时间": "Početno vrijeme",
  "店内订单": "Narudžba u trgovini",
  "自提订单": "Narudžba za preuzimanje",
  "外卖订单": "Narudžba za dostavu",
  "名称": "Ime",
  "支付时间": "Vrijeme plaćanja",
  "消费方式": "Način plaćanja",
  "状态": "Status",
  "单价": "Jedinična cijena",
  "金额": "Iznos",
  "税率": "Porezna stopa",
  "税费金额": "Iznos poreza",
  "邮箱地址": "Adresa e-pošte",
  "今天": "Danas",
  "昨天": "Jučer",
  "一周": "Jedan tjedan",
  "搜索": "Pretraga",
  "待完成": "U tijeku",
  "已完成": "Završeno",
  "已取消": "Otkazano",
  "全部": "Sve",
  "顾客信息": "Informacije o kupcu",
  "用户昵称": "Nadimak korisnika",
  "手机号": "Broj telefona",
  "收货地址": "Adresa dostave",
  "取单号": "Broj za preuzimanje narudžbe",
  "就餐方式": "Način jelovnika",
  "订单号": "Broj narudžbe",
  "订单金额": "Iznos narudžbe",
  "订单优惠": "Popust na narudžbu",
  "实付金额": "Stvarni iznos plaćen",
  "支付方式": "Način plaćanja",
  "备注信息": "Napomene",
  "期望配送时间": "Očekivano vrijeme dostave",
  "取餐时间": "Vrijeme preuzimanja",
  "配送费": "Naknada za dostavu",
  "退款金额": "Iznos povrata novca",
  "准备中": "Priprema u tijeku",
  "出餐中": "Kuhanje u tijeku",
  "待取餐": "Čekanje na preuzimanje",
  "订单信息": "Informacije o narudžbi",
  "税费详情": "Detalji o porezu",
  "取消订单": "Otkazivanje narudžbe",
  "打印小票": "Printanje računa",
  "出餐": "Posluživanje jela",
  "确认送达": "Potvrdi dostavu",
  "退款": "Povrat novca",
  "已退款": "Povrat novca izvršen",
  "请输入订单号": "Molimo unesite broj narudžbe",
  "至": "Do",
  "开始日期": "Datum početka",
  "结束日期": "Datum završetka",
  "发送账单": "Pošalji račun",
  "请输入邮箱地址": "Molimo unesite svoju adresu e-pošte",
  "确定要催菜吗?": "Jeste li sigurni da želite požuriti narudžbu?",
  "确定要完成订单吗?": "Jeste li sigurni da želite završiti narudžbu?",
  "确定要出餐吗?": "Jeste li sigurni da želite poslužiti jela?",
  "确定要发送账单吗?": "Jeste li sigurni da želite poslati račun?",
  "邮箱不能为空": "Adresa e-pošte ne može biti prazna",
  "确定要取消订单吗?": "Jeste li sigurni da želite otkazati narudžbu?",
  "是否确认此操作?": "Jeste li sigurni da želite potvrditi ovu operaciju?",
  "上传文件只能是excel格式!": "Datoteka mora biti u formatu Excel!",
  "上传文件大小不能超过 10MB!": "Veličina datoteke ne smije prelaziti 10MB!",
  "正在处理,请等待": "Obrada u tijeku, molimo pričekajte",
  "本次处理失败": "Obrada nije uspjela ovaj put",
  "总金额": "Ukupan iznos",
  "可退款金额": "Iznos povratka novca",
  "请输入退款金额": "Molimo unesite iznos povratka novca",
  "超出可退款金额": "Premašuje iznos povratka novca",
  "404错误页面": "404 Stranica greške",
  "合计": "Ukupno",
  "份": "Dio",
  "余额支付": "Plaćanje Salda",
  "线下支付(现金支付)": "Naljepnice za plaćanje (gotovinsko plaćanje)",
  "线下支付(微信支付)": "Naljepnice za plaćanje (vlastito plaćanje WeChata)",
  "线下支付(支付宝支付)": "Naljepnice za plaćanje (vlastito plaćanje Alipaya)",
  "线下支付(POS刷卡支付)": "Naljepnice za plaćanje (POS kartično plaćanje)",
  "进行中": "U Tijeku",
  "待付款": "Nepotpuno Plaćanje",
  "待配送": "Čeka na Dostavu",
  "配送中": "U Dostavi",
  "待接单": "Čeka na Prihvaćanje",
  "待取货": "Čeka na Preuzimanje",
  "已配送": "Dostavljeno",
  "已收货": "Primljeno",
  "待收货": "Očekuje Se Isporuka",
  "待取消": "Čeka na Otkazivanje",
  "会员": "Član",
  "商家": "Trgovac",
  "供应商": "Dobavljač",
  "分销": "Distribucija",
  "通知": "Obavijest",
  "已付款": "Plaćeno",
  "用户下单": "Korisnik Nalagao",
  "收银台下单": "Narudžba na Blagajni",
  "扫码下单": "Narudžba Skeniranjem",
  "团购下单": "Narudžba za Grupu",
  "商城订单": "Narudžba Trgovine",
  "积分商城订单": "Narudžba Trgovine Bodova",
  "余额充值订单": "Narudžba Punjenja Salda",
  "购卡订单": "Narudžba Kupnje Kartice",
  "券包订单": "Narudžba Paketa Vaučera",
  "配送员押金订单": "Narudžba Depozita za Dostavljače",
  "团购订单": "Narudžba Grupne Kupnje",
  "下单减库存": "Smanjenje Zalihe Pri Narudžbi",
  "付款减库存": "Smanjenje Zalihe Pri Plaćanju",
  "商家配送": "Dostava od Strane Trgovca",
  "外卖配送": "Dostava Na Doma",
  "到店自提": "Samostalno Preuzimanje",
  "快递配送": "Ekspresna Dostava",
  "个人中心": "Osobni Centar",
  ...hrLocale
}



export default hr



// WEBPACK FOOTER //
// ./src/i18n/langs/hr.js